module.exports = __webpack_public_path__ + "img/niu11.8d1d07c0.jpg";